<template>
  <button :style="{color: iconColor, fontSize: '40px'}">&#9862;</button>
</template>

<script>
import Vue from "vue";
import { io } from "socket.io-client";
import { mapState } from "vuex";
import { EventBus } from "@/eventBus";
export default {

  data() {
    return {
      socket: null,
      connected: false
    };
  },
  computed: {
    ...mapState({
      locales: (state) => state.locales.locales,
      time: (state) => state.auth.time,
      order: (state) => state.order.order,
    }),
    iconColor() {
      return this.connected ? 'chartreuse' : 'red'
    },
  },
  methods: {
    currentState() {
      let userState;

      switch (+window.sessionStorage.getItem('state')){
        case 0:
          userState = 'online';
          break;
        case 1:
          userState = 'is-ready';
          break;
        case 2:
          userState = 'training'
          break;
        default:
          userState = 'online';
      }

      if(this.order){
        userState =  'opened-order';
      }

      return userState;

    },
    beforeDestroy() {
      if (this.socket) {
        this.socket.disconnect();
      }
    },
    connectToApiSocket() {
      const token = Vue.auth.getToken();
      const username = Vue.auth.getUser().username;


      this.socket = io("https://unicall.io", {
        path: "/socket/socket.io/",
        query: {
          token: token,
          username: username,
          state: this.currentState(),
        },
        transports: ["websocket"],
      });

      this.socket.on("connect", () => {
        this.connected = true;
        console.log("Connected to WebSocket server");
      });

      this.socket.on("disconnect", (reason) => {
        this.connected = false;
        console.log(`Disconnected from WebSocket server: ${reason}`);
      });

      this.socket.on("clean old session", () => {
          const appElement = document.getElementById("app");
          const appVueInstance = appElement ? appElement.__vue__ : null;
          if (appVueInstance) {
            appVueInstance.$destroy();
          }
          document.body.innerHTML = "";
          document.body.textContent = "Another opened tab has been detected. Disconnected by server. Reload the page to reconnect.";
      })

      this.socket.on("initialTime", (data) => {
        console.log("initialTime time:", data);
      });

      this.socket.on("command", (data) => {
        console.log("Command:", data);
        if(data === 'reload'){
          window.location.reload();
        }
      });
    }
  },
  mounted() {
    this.connectToApiSocket();
    EventBus.$on('opened-order', () => {
      this.socket.emit("statusUpdate", 'opened-order', {orderId: this.order.order.id})
    });
    EventBus.$on('change-ready', () => {
      this.socket.emit("statusUpdate", this.currentState())
    })
    EventBus.$on('saved-order', () => {
      this.socket.emit("statusUpdate", this.currentState(), {})
    });
    EventBus.$on('stop-calling', () => {
        const data = this.order ? {orderId: this.order.order.id} : {};
        this.socket.emit("statusUpdate", this.currentState(), data)
    });
    EventBus.$on('start-calling', () => {
      const data = this.order ? {orderId: this.order.order.id} : {};
      this.socket.emit("statusUpdate", 'calling', data)
    });
  },
};
</script>

<style lang="scss" scoped>

</style>
